import { X } from "lucide-react";
import { Reveal } from "../motion/Reveal";
import { painPoints } from "../../data/academyData";

export const ProblemAgitation = () => (
  <section id="problem" data-testid="problem-agitation-section" className="relative py-20 md:py-32 bg-[#08080A] border-t border-white/[0.06]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-rose-400 font-semibold mb-4">The Problem Nobody Talks About</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-white max-w-3xl leading-tight">
          India has over a billion people. Yet sex, intimacy & relationships remain the most misunderstood subjects in every Indian adult's life.
        </h2>
        <p className="mt-6 text-zinc-400 text-lg max-w-2xl leading-relaxed">
          Nobody taught you about your body in school. Nobody taught you about desire, boundaries or performance at home. And everything you learned from the internet? Most of it was wrong.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-4">
        {painPoints.map((point, i) => (
          <Reveal key={point} delay={i * 0.05}>
            <div className="flex items-start gap-4 p-5 rounded-xl bg-white/[0.03] border border-white/10" data-testid={`pain-point-${i}`}>
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-rose-600/15 text-rose-400"><X size={14} /></span>
              <span className="text-zinc-300 text-base">{point}</span>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-14 flex items-center gap-4 border-l-2 border-rose-500 pl-6">
          <p className="text-xl sm:text-2xl font-heading text-white italic">This is not your fault. But it is now your responsibility to change it.</p>
        </div>
      </Reveal>
    </div>
  </section>
);
